import React, {useEffect, useState} from "react";
import OrderHeadSectionComponent from "../../components/headSection/components/OrderHeadSectionComponent";
import ProfilePath from "../profileSection/components/ProfilePath";
import {useDispatch} from "react-redux";
import ContactSectionComponent from "../../pages/main/sections/contactSection/ContactSectionComponent";
import HelpWithOrderFormComponent from "./components/HelpWithOrderFormComponent";
import "./helpWithOrderComponent.scss"
import QuestionHelpList from "./components/QuestionHelpList";
import {getQuestionData} from "../../actions/data";
import {useNavigate, useParams} from "react-router-dom";
import { useTranslation } from "react-i18next";

const HelpWithOrderComponent = () => {
    const { t } = useTranslation();
    const {category, faq} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [worrySearch, setWorrySearch] = useState<string>('');
    const [selectedProblem, setSelectedProblem] = useState<string>('');
    const [questionsData, setQuestionsData] = useState<any[]>([]);

    const handleButtonFormSendHelpMessage = async () => {
        try {
            navigate('/help-with-order/faq');
        } catch (e) {
            console.log("error e: ", e);
        }
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const fetchData = async () => {
            try {
                const response = await getQuestionData(dispatch);
                if (response) {
                    console.log("response: ", response);
                    setQuestionsData(response);
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        fetchData().then();
/*        const fetchQuestions = async () => {
            try {
                const response = await fetch('http://localhost:5000/api/auth/questions');
                const content = await response.json();
                setQuestions(content);
            } catch (e) {
                console.log("error e: ", e);
            }
        }
        fetchQuestions().then(() => console.log("fetch questions"));*/
    }, [worrySearch, dispatch]);

    return (
        <div className="helpWithOrderComponent">
            <div className="mainSectionComponent__container-content-overlay"></div>
            <OrderHeadSectionComponent />
            <ProfilePath
                path={['Help with order', faq ? 'FAQ' : '']}
                component="Help with order"
            />
            <div className="helpWithOrderComponent__container-content">
                <div className="helpWithOrderDataForm__container_content_help_problem_title">
                    <span>{t('helpWithOrder.hereToHelp')}</span>
                </div>

                <form className="helpWithOrderDataForm__container_content_form help_problem">
                    <div className="helpWithOrderDataForm__container_content_form_input_wrap">
                        <div className="helpWithOrderDataForm__container_content_form_input_search_wrap">
                            <input
                                type="text"
                                id="type-name"
                                name="type-name"
                                required
                                placeholder={t('helpWithOrder.typeInYour')}
                                value={worrySearch}
                                onChange={(e) => setWorrySearch(e.target.value)}
                            />
                            <div className="helpWithOrderDataForm__container_content_form_input_search_icon_wrap">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/magnifier.svg`}
                                    alt="magnifier"
                                />
                            </div>
                        </div>
                    </div>
                </form>

                {
                    faq ? (
                        <QuestionHelpList
                            worrySearch={worrySearch}
                            setWorrySearch={setWorrySearch}
                            selectedProblem={selectedProblem}
                            questionsData={questionsData}
                        />
                    ) : (
                        questionsData && worrySearch !== '' ? (
                            <QuestionHelpList
                                worrySearch={worrySearch}
                                setWorrySearch={setWorrySearch}
                                selectedProblem={selectedProblem}
                                questionsData={questionsData}
                            />
                        ) : (
                            <HelpWithOrderFormComponent
                                handleButtonFormSendHelpMessage={handleButtonFormSendHelpMessage}
                                handleRadioChange={(value) => setSelectedProblem(value)}
                                selectedProblem={selectedProblem}
                                worrySearch={worrySearch}
                                setWorrySearch={setWorrySearch}
                            />
                        )
                    )
                }

            </div>
            <ContactSectionComponent />
        </div>
    );
}

export default HelpWithOrderComponent;